<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-card>
				<v-card-title primary-title>
					{{ $t("title.edit_product") }}
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<ShopFormProduct
						v-model="item"
						:categories="categories"
						:subcategories="subcategories"
						:units="units"
						:taxes="taxes"
						:parents="parents"
					></ShopFormProduct>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						@click.native="submit()"
						:loading="item.processing"
						:disabled="invalid"
					>
						<v-icon left>mdi-content-save</v-icon>
						{{ $t("Update") }}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</ValidationObserver>
	</v-container>
</template>

<script>
import ShopFormProduct from "@Shop/forms/ShopFormProduct.vue";
export default {
	components: {
		ShopFormProduct,
	},
	props: [
		"product",
		"categories",
		"subcategories",
		"units",
		"taxes",
		"parents",
	],
	data() {
		return {
			item: this.$inertia.form(this.product),
		};
	},
	methods: {
		submit() {
			this.item.put(
				this.$route("tenant.products.update", {
					tenant: this.$page.props.tenant.id,
					product: this.item.uuid,
				})
			);
		},
	},
};
</script>